import { Space } from 'antd'
import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import { useDSNotificationsContext } from '../../DSNotificationsContext'
import RecipientsTags from 'components/CIMSTags/common/RecipientsTags'
import CIMSCollapse from 'components/CIMSCollapse'
import GroupFallback from '../GroupFallback'
import NotConfigured from './components/NotConfigured'
import { HelpMessage } from 'utils/constants'
import { DSNotificationEvent, alphabeticalSort } from '@cims-online/shared'
import ApproverTags from '../ApproverTags'
import CIMSSection from 'components/CIMSSection'
const Help = HelpMessage.DesignSubmittals.Notifications

const ViewDSNotificationEvent: React.FC = () => {
  const { event } = useCIMSNotificationsPanelContext()
  const { data } = useDSNotificationsContext()
  const { every, byDSDiscipline } =
    useDSNotificationsContext().recipients(event)

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <CIMSSection
        help={HelpMessage.Notifications.Every(event, 'Design Submittal')}
        title={`Every ${event.name} Event`}
      >
        <RecipientsTags
          noRecipientsContent={<NotConfigured type="every" />}
          recipients={every}
        />
      </CIMSSection>
      <CIMSSection help={Help.ByDiscipline(event)} title="Discipline">
        <CIMSCollapse
          noPanelsContent={<GroupFallback />}
          panels={data?.dsDisciplines
            ?.sort(alphabeticalSort('name'))
            .map(({ id: key, name, description }) => {
              const recipients = byDSDiscipline.find(
                ({ discipline }) => discipline.id === key
              )?.recipients
              return {
                key,
                header: {
                  type: 'described',
                  name,
                  description,
                },
                children: (
                  <Space size="large" direction="vertical">
                    {event === DSNotificationEvent.RoutedToDisciplineAction && (
                      <ApproverTags discipline={{ id: key, name }} />
                    )}
                    <RecipientsTags
                      noRecipientsContent={
                        <NotConfigured
                          type="group"
                          groupName={'Disciplines'}
                          itemName={name}
                        />
                      }
                      recipients={recipients}
                    />
                  </Space>
                ),
              }
            })}
        />
      </CIMSSection>
    </Space>
  )
}

export default ViewDSNotificationEvent
